export default class User {
   constructor(bxItem) {
      this.id = bxItem.ID;
      this.name = bxItem.NAME;
      this.secondName = bxItem.SECOND_NAME;
      this.lastName = bxItem.LAST_NAME;
   }

   get fio() {
      return [this.name, this.secondName, this.lastName]
         .filter(str => str && str.trim() !== '')
         .map(str => str.trim())
         .join(' ')
   }
}